<script>
    import Main from './layout/Main.svelte';
    import Breadcrumb from "../com/ui/Breadcrumb.svelte";
    import { t } from "../i18n";


    var inputSubject = null;
    var inputMessage = null;


    let sendEmail = function()
    {
        let EMAIL = 'contact@fivetravel.ma';
        let subject = inputSubject.value||'';
        let message = inputMessage.value||'';
        window.location.href = 'mailto:'+EMAIL+'?subject='+encodeURIComponent(subject)+'&body=' + encodeURIComponent(message);
    }

</script>


<Main title={$t('page.help')}>


    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">
            <div class="content-header row">
                <div class="content-header-left col-12 mb-2 mt-1">
                    <div class="row breadcrumbs-top">
                        <div class="col-12">
                            <Breadcrumb path="home => {$t('breadcrumb.help')}"></Breadcrumb>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-body">


                <!-- Basic Inputs start -->
                <section id="basic-input">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="card-title">{$t('help.title')}</h4>
                                </div>
                                <div class="card-content">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <fieldset class="form-group">
                                                    <label for="basicInput">{$t('help.subject')}</label>
                                                    <input bind:this={inputSubject} type="text" class="form-control" id="basicInput" placeholder={$t('help.subject_placeholder')}>
                                                </fieldset>
                                            </div>
                                            <div class="col-md-12">
                                                <fieldset class="form-group">
                                                    <label>{$t('help.message')}</label>
                                                    <textarea bind:this={inputMessage} class="form-control" cols="30" rows="10" placeholder={$t('help.message_placeholder')}></textarea>
                                                </fieldset>
                                            </div>
                                            <div class="col-md-12">
                                                <button class="btn btn-primary" type="submit" on:click={()=>sendEmail()} >{$t('help.submit')}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- Basic Inputs end -->

            </div>
        </div>
    </div>


</Main>

